import "./errorBox.scss"
export default function ErrorBox ({errorMessage}) {
    return (
        <span className="errorBox">
        {errorMessage}
        </span>
    )
}